import React, { useEffect, useState } from "react";
import Search from "../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg27 from "../../../../../assets/svg/svg27.svg";
import svg15 from "../../../../../assets/svg/svg15.svg";
import svg29 from "../../../../../assets/svg/svg29.svg";
import svg49 from "../../../../../assets/svg/svg49.svg";
import CardLoading from "../../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../../../features/obj/objSlice";
import { formatText } from "../../../../../utils";
import useModalToggle from "../../../../../custom_hooks/useModalToggle";
import ProjectView from "./ProjectView";
import AssignProject from "./modal/AssignProject";
import ConfirmModal from "../../../../../components/ConfirmModal";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";

function ProjectTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/getFarmers";
  const urlProj = "api/v2/flid/projects/get";

  const { loading, data, count, activeObjPartners } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    activeObjPartners: state.obj.activeObj["partners"],
  }));

  const { refetchKey } = useSelector((state) => state.global);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        fullName: e.target.value == "" ? null : e.target.value,
      })
    );
  };
  const { open, handleCancel, handleOpen } = useModalToggle();

  const handleView = async () => {
    await dispatch(setActiveObj(prodd));
    await showDrawer();
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/flid/projects/deAssignToVerifier",
        projectList: prodd?.projectId,
        verifierId: activeObjPartners?.ipId
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4">
            <img src={svg15} alt="svg15" />{" "}
            <span className="whitespace-nowrap">View</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4">
            <img src={svg49} alt="svg49" />{" "}
            <span className="whitespace-nowrap">Unassign</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project",
      dataIndex: "fullNames",
      sorter: (a, b) => a.fullNames.localeCompare(b.fullNames),
    },

    {
      title: "Date Registered",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "County",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: "Consituency",
      dataIndex: "usrNationalId",
      sorter: (a, b) => a.usrNationalId.localeCompare(b.usrNationalId),
    },
    {
      title: "Scheme Type",
      dataIndex: "countyName",
      sorter: (a, b) => a.countyName.localeCompare(b.countyName),
    },
    {
      title: "Farm Size",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: "Irrigation Type",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: "Cost",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: "Status",
      dataIndex: "usrStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PENDING_APPROVAL: "#3250FF",
          INACTIVE: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },

    // {
    //   title: "Actions",
    //   render: (item) => (
    //     <>
    //       <button onClick={() => handleView(item)}>
    //           <img src={svg15} alt="svg15" />
    //         </button>
    //     </>
    //   ),
    // },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [pageIndexProj, setPageIndexProj] = useState(0);
  const [pageSizeProj, setPageSizeProj] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function fetchTableDataProj(page, size) {
    await dispatch(
      fetchData({
        url: urlProj,
        limit: size ?? pageSizeProj,
        start: page ?? pageIndexProj, 
        projectStatus: 'INSTALLED',
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 3) {
      fetchTableData();
      fetchTableDataProj();
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <div className="flex flex-col w-full   ">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between   gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>

          <div className="w-[150px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />
              <span className="">Assign Project</span>
            </button>
          </div>
        </div>

        <div className="dash-inner-page mt-[1rem] max-w-full w-full overflow-x-auto">
          <section>
            <Table
              rowSelection={false}
              className=" w-full"
              scroll={{
                x: 1200,
              }}
              rowKey={(record) => record?.usrId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchTableData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}
            />
          </section>
        </div>
      </div>
      <ProjectView onClose={onClose} open={openDrawer} />
      <AssignProject
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        handleFetchProj={fetchTableDataProj}
        prodd={prodd}
        setPageIndex={setPageIndexProj}
        setPageSize={setPageSizeProj}
        pageIndex={pageIndexProj}
        pageSize={pageSizeProj}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content={`Are you sure you want to unassign ${activeObjPartners?.mipName} project for farmer ${prodd?.farmerName}`}
        type="alert"
        btnTitle="Unasign"
      />
    </div>
  );
}

export default ProjectTable;
